import { PageRenderer } from "../../../components/PageRenderer";
import { Text } from "../../../components/Text";
import type { HeadlineVariantProps, PostSubmitContext } from "../../../types/config";
import type { PageConfig } from "../../../types/PageConfig";

export interface PageProps {
  config: PageConfig | null;
  pageName: string;
  headlineVariant?: HeadlineVariantProps | null;
  postSubmit?: PostSubmitContext | null;
}

export function Page({ config, pageName, headlineVariant, postSubmit }: PageProps) {
  if (!config) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <Text variant="title" as="h1" className="text-fg mb-4">
            404
          </Text>
          <Text variant="body-lg" as="p" className="text-muted">
            Page "{pageName}" not found
          </Text>
        </div>
      </div>
    );
  }

  return (
    <PageRenderer
      config={config}
      headlineVariant={headlineVariant ?? null}
      postSubmit={postSubmit ?? null}
    />
  );
}
